import { render, staticRenderFns } from "./LayoutApplicationLimitedInformationStatement.vue?vue&type=template&id=a5d02896&scoped=true&"
import script from "./LayoutApplicationLimitedInformationStatement.vue?vue&type=script&lang=js&"
export * from "./LayoutApplicationLimitedInformationStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d02896",
  null
  
)

export default component.exports